<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-7 col-lg-5">

      <div class="card shadow-lg border-0 rounded-4">

        <!-- HEADER -->
        <div class="card-header bg-primary bg-gradient text-white py-4 rounded-top-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="mb-1 fw-semibold text-white">Cambio de Contraseña</h4>
              <small class="opacity-75">Actualiza tu clave de acceso</small>
            </div>
            <img src="assets/images/profile-img.png" class="img-fluid" style="max-height:65px;">
          </div>
        </div>

        <!-- BODY -->
        <div class="card-body p-4">

          <div class="text-center mb-3">
            <img src="assets/images/volumetricos.png" height="50" />
          </div>

          <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

            <!-- Error -->
            <ngb-alert type="danger" *ngIf="error" class="mb-3">
              {{ error }}
            </ngb-alert>

            <!-- Password -->
            <div class="mb-3">
              <label class="form-label fw-semibold">Nueva Contraseña</label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="fas fa-lock"></i></span>
                <input type="password"
                       class="form-control"
                       placeholder="Ingresa nueva contraseña"
                       formControlName="password"
                       [ngClass]="{ 'is-invalid': submitted && f.password.errors }">

                <div class="invalid-feedback">
                  <div *ngIf="f.password.errors?.required">La contraseña es obligatoria.</div>
                  <div *ngIf="f.password.errors?.pattern">
                    Debe tener 8 caracteres, número, mayúscula, minúscula y símbolo.
                  </div>
                </div>
              </div>
            </div>

            <!-- Confirmación -->
            <div class="mb-4">
              <label class="form-label fw-semibold">Confirmar Contraseña</label>
              <div class="input-group">
                <span class="input-group-text bg-light"><i class="fas fa-check"></i></span>
                <input type="password"
                       class="form-control"
                       placeholder="Repite la contraseña"
                       formControlName="password2"
                       [ngClass]="{ 'is-invalid': submitted && f.password2.errors }">

                <div class="invalid-feedback">
                  <div *ngIf="f.password2.errors?.required">Debes confirmar la contraseña.</div>
                  <div *ngIf="f.password2.errors?.confirmedValidator">
                    Las contraseñas no coinciden.
                  </div>
                </div>
              </div>
            </div>

            <!-- Botón -->
            <button type="submit" class="btn btn-primary w-100 py-2 fw-semibold">
              Cambiar Contraseña
            </button>
          </form>

          <!-- Footer -->
          <div class="text-center mt-4">
            <img src="assets/images/volumetricos.png" height="40" class="mb-2" />
            <p class="text-muted small">© {{year}} SGP — Diseño MBQ</p>
          </div>

        </div>

      </div>

    </div>
  </div>
</div>
